// frontend/app/ConfettiOverlay.js
import React from "react";
import { Platform, View } from "react-native";

export default function ConfettiOverlay({ show, onComplete }) {
  const [WebConfetti, setWebConfetti] = React.useState(null);
  const [size, setSize] = React.useState({ width: 0, height: 0 });

  // Load the library only on web; avoid bundling for native
  React.useEffect(() => {
    if (Platform.OS !== "web") return;

    let mounted = true;

    // dynamic import is more reliable than require() in RNW/Expo web builds
    import("react-confetti")
      .then((m) => {
        if (mounted) setWebConfetti(() => m.default);
      })
      .catch((e) => {
        console.warn("[ConfettiOverlay] Failed to load react-confetti:", e);
      });

    const update = () =>
      setSize({ width: window.innerWidth, height: window.innerHeight });

    update();
    window.addEventListener("resize", update);

    return () => {
      mounted = false;
      window.removeEventListener("resize", update);
    };
  }, []);

  if (!show) return null;
  if (Platform.OS !== "web" || !WebConfetti) {
    // graceful no-op for native or if library not yet loaded
    return <View />;
    // If you want to see it try to load, uncomment:
    // return <View style={{ position: "absolute", top: 0, left: 0 }} />;
  }

  // High z-index, fixed, non-blocking overlay
  return (
    <View
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 999999,
        pointerEvents: "none",
      }}
    >
      <WebConfetti
        width={size.width}
        height={size.height}
        numberOfPieces={320}
        recycle={false}
        onConfettiComplete={onComplete}
      />
    </View>
  );
}
